import { deepMergeStyles } from '../../mergeStyles/mergeStyles/index.js';
import '../../../colors/accents/accents/index.js';
import '../../../colors/backgrounds/backgrounds/index.js';
import '../../../colors/texts/texts/index.js';
import { ThemeLightValues, ThemeDarkValues } from '../../../colors/themes/themes/index.js';
import { addLightness, opacify } from '../../../colorMutators/colorMutators/index.js';

var ThemeMode;
(function (ThemeMode) {
    ThemeMode["Dark"] = "dark";
    ThemeMode["Light"] = "light";
})(ThemeMode || (ThemeMode = {}));
const generateTextValues = (baseColor, isDark = false, lightnessValues = null) => {
    // eslint-disable-next-line no-param-reassign
    lightnessValues = lightnessValues || (isDark ? [-30, -50, -60] : [29.8, 50, 60]);
    const positive = isDark ? '#000000' : '#ffffff';
    const negative = isDark ? '#ffffff' : '#000000';
    return Object.freeze({
        positive,
        negative,
        base: baseColor,
        tint1: addLightness(baseColor, lightnessValues[0]),
        tint2: addLightness(baseColor, lightnessValues[1]),
        tint3: addLightness(baseColor, lightnessValues[2]),
    });
};
const generateBackgroundValues = (baseColor, isDark = false, lightnessValues = null) => {
    // eslint-disable-next-line no-param-reassign
    lightnessValues = lightnessValues || (isDark ? [4, 8, 12, 20, 28, 36] : [-2, -4, -8, -12, -16, -20]);
    const positive = isDark ? '#000000' : '#ffffff';
    const negative = isDark ? '#ffffff' : '#000000';
    const canvasBackLayer = isDark ? '#262626' : '#ededed';
    const opacity = isDark ? 60 : 52;
    const backgroundsArray = lightnessValues && lightnessValues.map(value => addLightness(baseColor, value));
    return Object.freeze({
        base: backgroundsArray[0],
        tint1: backgroundsArray[1],
        tint2: backgroundsArray[2],
        tint3: backgroundsArray[3],
        tint4: backgroundsArray[4],
        tint5: backgroundsArray[5],
        tint6: backgroundsArray[6],
        transparent: opacify('#000', opacity),
        panel: opacify(backgroundsArray[2], 60),
        gradientUp: `linear-gradient(360deg, ${opacify(backgroundsArray[0], 80)} 0%, transparent 100%)`,
        gradientDown: `linear-gradient(180deg, ${opacify(backgroundsArray[0], 80)} 0%, transparent 100%)`,
        positive,
        negative,
        canvasBackLayer,
    });
};
const generateTheme = (customTheme, isDark = ThemeMode.Light) => Object.freeze(deepMergeStyles({ ...(isDark === ThemeMode.Light ? ThemeLightValues : ThemeDarkValues) }, customTheme));

export { ThemeMode, generateBackgroundValues, generateTextValues, generateTheme };
